"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ChatInput: ()=>ChatInput
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_react_namespaceObject = require("react");
const external_submitChatMessages_js_namespaceObject = require("../../submitChatMessages.js");
const ChatbotDataContext_js_namespaceObject = require("../../context/ChatbotDataContext.js");
const external_UserInputBar_js_namespaceObject = require("./UserInputBar.js");
var external_UserInputBar_js_default = /*#__PURE__*/ __webpack_require__.n(external_UserInputBar_js_namespaceObject);
const pennyBroadcast_js_namespaceObject = require("../../utils/pennyBroadcast.js");
var pennyBroadcast_js_default = /*#__PURE__*/ __webpack_require__.n(pennyBroadcast_js_namespaceObject);
const sanitizeInput_js_namespaceObject = require("../../utils/sanitizeInput.js");
var sanitizeInput_js_default = /*#__PURE__*/ __webpack_require__.n(sanitizeInput_js_namespaceObject);
const index_js_namespaceObject = require("../InputLimiter/index.js");
var index_js_default = /*#__PURE__*/ __webpack_require__.n(index_js_namespaceObject);
const external_index_js_namespaceObject = require("../../index.js");
const ChatInput = ({ styles, isAudioPlaybackEnabledRef, submitChatMessagesOptions, showToolTip })=>{
    const { isDisablingInput, enableVoiceTooltip, submitChatMessagesPayload, setErrorMessage, logFirstMessageSubmitted } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    const { isLoading } = (0, external_index_js_namespaceObject.useLoadingStateContext)();
    const { setOpenErrorComponent } = (0, external_index_js_namespaceObject.useChatUIContext)();
    const { chatMessages, setChatMessages } = (0, external_index_js_namespaceObject.useChatMessagesContext)();
    const [inputLength, setInputLength] = (0, external_react_namespaceObject.useState)(0);
    function handleLimiter(length) {
        setInputLength(length);
    }
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
        ...styles.inputStyle,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_UserInputBar_js_default(), {
                styles: styles,
                isDisablingInput: isDisablingInput,
                isLoading: isLoading,
                enableVoiceTooltip: enableVoiceTooltip,
                onTextSubmit: function(msg) {
                    setErrorMessage('');
                    const chatMessage = {
                        role: 'user',
                        content: sanitizeInput_js_default()(msg),
                        date: new Date()
                    };
                    const promptMessage = {
                        role: 'user',
                        content: sanitizeInput_js_default()(msg)
                    };
                    const updatedChatMessages = [
                        ...chatMessages,
                        chatMessage
                    ];
                    setChatMessages([
                        ...chatMessages,
                        chatMessage
                    ]);
                    pennyBroadcast_js_default()({
                        type: pennyBroadcast_js_namespaceObject.BroadcastType.USER_SUBMITTED_TEXT,
                        data: sanitizeInput_js_default()(msg),
                        sender: 'ChatContent.onTextSubmit()'
                    });
                    (0, external_submitChatMessages_js_namespaceObject.submitChatMessages)({
                        submitChatMessagesPayload: {
                            ...submitChatMessagesPayload,
                            prompts: [
                                promptMessage
                            ]
                        },
                        setOpenErrorComponent,
                        chatMessages: updatedChatMessages,
                        ...submitChatMessagesOptions
                    });
                    logFirstMessageSubmitted(chatMessages);
                },
                limiterCheck: handleLimiter
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_js_default(), {
                currentLength: inputLength
            }),
            showToolTip ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                justifyContent: "center",
                alignItems: "left",
                width: "100%",
                mb: 2,
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_index_js_namespaceObject.PennyToolTip, {
                    msgPosition: "top",
                    styles: styles
                })
            }) : null
        ]
    });
};
exports.ChatInput = __webpack_exports__.ChatInput;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ChatInput"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
